module.exports = __webpack_public_path__ + "app/modals/notice-create-edit-modal.view.html";